import { FC } from 'react'

import './style.scss'
import loadingGif from '../../../assets/img/loading.gif'

type LoadingProps = {
  className?: string,
  size?: 'sm' | 'md' | 'lg' | '',
  align?: 'center' | 'right' | 'left' | '',
  overlay?: boolean
}

const LoadingImg = <img src={loadingGif} alt="Loading" width="40" height="40" />

const Loading:FC<LoadingProps> = ({ className = '', size = '', align = '', overlay = false })  => {
  const options: string = `${size ? 'loading--' + size : ''} ${align ? 'text-' + align : ''} ${className}`

  if(overlay) return <div className={`loading-overlay ${options}`}>{LoadingImg}</div>

  return <div className={`${options}`}>{LoadingImg}</div>
}

export { Loading }